import { MILLISECONDS } from 'constants/time';
import { useEffect, useState } from 'react';

/**
 * Keep track of the refreshed age in milliseconds
 */
export const useLastRefreshed = (lastRefreshed: Date, refreshRateSeconds = 1): number => {
  const [age, setAge] = useState<number>(Date.now() - lastRefreshed.getTime());

  useEffect(() => {
    const interval = setInterval(
      () => setAge(Date.now() - lastRefreshed.getTime()),
      MILLISECONDS.second * refreshRateSeconds
    );

    return () => clearInterval(interval);
  }, [lastRefreshed, refreshRateSeconds]);

  return age;
};
